const Report = () =>
  import(
    /* webpackChunkName: "courier-couriers" */ '@/pages/courier/couriers/index.vue'
  )
const Detail = () =>
  import(
    /* webpackChunkName: "courier-couriers" */ '@/pages/courier/couriers/detail.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "courier-couriers" */ '@/pages/courier/couriers/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "company-companies" */ '@/pages/courier/couriers/edit.vue'
  )

export default {
  path: 'couriers',
  meta: {
    label: 'company',
    auth: 'courier'
  },
  component: {
    name: 'Courier',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CompanyReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report,
      props: true
    },
    {
      name: 'CompanyDetail',
      path: 'detail/:id',
      meta: {
        label: 'detail',
        auth: 'detail'
      },
      component: Detail,
      props: true
    },
    {
      name: 'CompanyCreate',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'CompanyEdit',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
